import { createWithEqualityFn } from "zustand/traditional";

const useMatchupStore = createWithEqualityFn(
  (set, get) => ({
    fixtureId: null,
    setFixtureId: (fixtureId) => {
      set({ fixtureId: fixtureId });
    },

    players: null,
    setPlayers: (players) => {
      set({ players: players });
    },

    formation: null,
    setFormation: (formation) => {
      set({ formation: formation });
    },

    leagueSeasonData: null,
    setLeagueSeasonData: (leagueSeasonData) => {
      set({ leagueSeasonData: leagueSeasonData });
    },

    leagueSeasonId: null,
    setLeagueSeasonId: (leagueSeasonId) => {
      set({ leagueSeasonId: leagueSeasonId });
    },

    playerStats: null,
    prevPlayerStats: null,
    setPlayerStats: (newStats) => {
      set((state) => ({
        prevPlayerStats: state.playerStats, // Save current stats as prev stats
        playerStats: newStats, // Update current stats with new stats
      }));
    },

    team1: null,
    setTeam1: (team1) => {
      set({ team1: team1 });
    },

    team2: null,
    setTeam2: (team2) => {
      set({ team2: team2 });
    },

    sportFixtures: null,
    setSportFixtures: (sportFixtures) => {
      set({ sportFixtures: sportFixtures });
    },

    selectedTeam: "team1",
    setSelectedTeam: (selectedTeam) => {
      set({ selectedTeam: selectedTeam });
    },

    isRefreshing: false,
    setIsRefreshing: (isRefreshing) => {
      set({ isRefreshing: isRefreshing });
    },

    lastRefreshed: null,
    setLastRefreshed: (lastRefreshed) => {
      set({ lastRefreshed: lastRefreshed });
    },

    captainId: null,
    setCaptainId: (captainId) => {
      set({ captainId: captainId });
    },

    viceId: null,
    setViceId: (viceId) => {
      set({ viceId: viceId });
    },

    deputyId: null,
    setDeputyId: (deputyId) => {
      set({ deputyId: deputyId });
    },

    numCaptains: 0,
    setNumCaptains: (numCaptains) => {
      set({ numCaptains: numCaptains });
    },

    showProjStats: false,
    setShowProjStats: (showProjStats) => {
      set({ showProjStats: showProjStats });
    },

    // Actual team stats (stored separately for cleaner access)
    actualTeam1Stats: null,
    setActualTeam1Stats: (actualTeam1Stats) => {
      set({ actualTeam1Stats: actualTeam1Stats });
    },

    actualTeam2Stats: null,
    setActualTeam2Stats: (actualTeam2Stats) => {
      set({ actualTeam2Stats: actualTeam2Stats });
    },

    // Team stats with projected values included
    projTeam1Stats: null,
    setProjTeam1Stats: (projTeam1Stats) => {
      set({ projTeam1Stats: projTeam1Stats });
    },

    projTeam2Stats: null,
    setProjTeam2Stats: (projTeam2Stats) => {
      set({ projTeam2Stats: projTeam2Stats });
    },

    formula: null,
    setFormula: (formula) => {
      set({ formula: formula });
    },

    // Blended projected stats (actual + projected * (1 - pct_complete))
    projStats: null,
    setProjStats: (projStats) => {
      set({ projStats: projStats });
    },
  }),
  Object.is,
);

export default useMatchupStore;
